import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { SmoothScroll } from "./SmoothScroll";

export const PublicLayout = () => (
  <>
    <SmoothScroll />
    <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-wine focus:px-4 focus:py-2 focus:text-ivory">
      Skip to content
    </a>
    <Header />
    <main id="main">
      <Outlet />
    </main>
    <Footer />
  </>
);

export const PageHero = ({ eyebrow, title, text, testid }) => (
  <section className="mx-auto max-w-[1400px] px-6 pb-16 pt-40 md:px-10 md:pb-24 md:pt-52">
    <p className="eyebrow text-wine fade-up">{eyebrow}</p>
    <h1 data-testid={testid} className="fade-up mt-6 max-w-5xl font-serif text-5xl font-light leading-[1.02] tracking-tight text-wine md:text-7xl lg:text-[5.5rem]" style={{ animationDelay: "120ms" }}>
      {title}
    </h1>
    {text && (
      <p className="fade-up mt-8 max-w-xl text-base leading-relaxed text-charcoal/80 md:text-lg" style={{ animationDelay: "240ms" }}>
        {text}
      </p>
    )}
  </section>
);
